export default __webpack_public_path__ + "static/media/2.6df771b0.jpg";